import suenConfig from './suen-config'
import trauerportal from './trauerportal'
import getParameterByName from '../modules/get-parameter-by-name'
import consoleLogger from '../../../modules/console-logger'
import isServerSide from '../../../modules/is-server-side'
import stolConfig from './stol-config'
import { getStoredItem } from '../../../modules/stored-item'

const [consoleLog] = consoleLogger('Ads')

const index = () => {
  const allConfigFiles = {
    suenConfig,
    trauerportal,
  }
  if (!isServerSide()) {
    const forcedAdConfigFile = getStoredItem('forceAdConfigFile', true)

    if (getParameterByName('testConfigFile') !== undefined || forcedAdConfigFile) {
      let wantedTestConfigFile = forcedAdConfigFile ? forcedAdConfigFile : getParameterByName('testConfigFile')
      consoleLog(
        `Config File`,
        'Wanted ' + wantedTestConfigFile + ' - Found? ' + (allConfigFiles[wantedTestConfigFile] != null),
      )
      if (allConfigFiles[wantedTestConfigFile]) {
        return allConfigFiles[wantedTestConfigFile]
      }
    }

    const hostName = window.location.hostname
    if (hostName.includes('suedtirolnews.it')) {
      return suenConfig
    }
    if (hostName.includes('stol.it')) {
      return stolConfig
    }
    return false
  }
}

export default index
